import { openaiUsage } from "../openai/usage";
import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const grok = defineConnector({
  identifier: "grok",
  name: "Grok",
  tagLine: "xAI large language model API",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: () => "https://api\\.x\\.ai/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your xAI API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [xAI console](https://console.x.ai/) and generate an API key. See the [API docs](https://docs.x.ai/api) for details.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          placeholder: "xai-...",
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.x.ai/v1/models",
  },
  usage: openaiUsage(),
});
